import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { User } from 'interfaces/user';

interface CurrentUserState extends User {
  setCurrentUser: (user: User) => void;
  clearCurrentUser: () => void;
}
export const useCurrentUserStore = create<CurrentUserState>()(
  devtools(
    (set) => ({
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      status: '',
      cognitoID: '',
      roleID: '',
      organizationID: '',
      providers: null,
      providerID: '',
      role: null,
      organization: null,
      setCurrentUser: (user) =>
        set({
          id: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phone: user.phone,
          status: user.status,
          cognitoID: user.cognitoID,
          roleID: user.roleID,
          organizationID: user.organizationID,
          providers: user.providers,
          providerID: user.providerID,
          role: user.role,
          organization: user.organization,
        }),
      clearCurrentUser: () =>
        set({
          id: '',
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          status: '',
          cognitoID: '',
          roleID: '',
          organizationID: '',
          providers: null,
          providerID: '',
          role: null,
          organization: null,
        }),
    }),
    {
      name: 'CurrentUserStore',
      anonymousActionType: 'setCurrentUser',
      store: 'CurrentUserStore',
    }
  )
);
